/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { SearchableItem, SearchableSelectionType } from './interface';

export class IBISReport implements SearchableItem {
  CODE: number;
  NAME: string;

  // Helpers
  active = false;
  allowed = false;

  constructor(value: any = {}) {
    Object.assign(this, value);
  }

  static parseArray(json: any[]): IBISReport[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new IBISReport(j));
        }
      }
    }

    return arr;
  }

  getName(): string {
    return this.NAME;
  }

  getFullDetails(): string {
    return `${this.CODE} - ${this.NAME}`;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}
